// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"0528c3c3d9f0d94f","9335":"e6c6a9caf0f28945"}[chunkId] + ".css";
};